// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Preloader_Wrapper__ksTkv","Loader":"Preloader_Loader__1582_"};